import { create } from 'zustand';
import { auth } from './supabase';

const useGameStore = create((set, get) => ({
  // User state
  user: null,
  profile: null,
  isAuthenticated: false,

  // Game state
  levels: [],
  currentLevel: null,
  achievements: [],
  userAchievements: [],
  concepts: [],
  learnedConcepts: [],
  nodeTypes: [],

  // UI state
  showTutorial: false,
  tutorialStep: 0,
  sandboxVisits: 0,

  // Actions
  setUser: (user) => set({ user, isAuthenticated: true }),
  setProfile: (profile) => set({ profile }),
  logout: async () => {
    await auth.signOut();
    set({ user: null, profile: null, isAuthenticated: false });
  },
  
  setLevels: (levels) => set({ levels }),
  setCurrentLevel: (level) => set({ currentLevel: level }),
  
  setAchievements: (achievements) => set({ achievements }),
  setUserAchievements: (userAchievements) => set({ userAchievements }),
  
  setConcepts: (concepts) => set({ concepts }),
  setLearnedConcepts: (learnedConcepts) => set({ learnedConcepts }),
  
  setNodeTypes: (nodeTypes) => set({ nodeTypes }),
  
  toggleTutorial: () => set((state) => ({ showTutorial: !state.showTutorial })),
  nextTutorialStep: () => set((state) => ({ tutorialStep: state.tutorialStep + 1 })),
  resetTutorial: () => set({ tutorialStep: 0, showTutorial: false }),
  
  incrementSandboxVisits: () => set((state) => ({ sandboxVisits: state.sandboxVisits + 1 })),
  
  // Computed getters
  getUnlockedAchievements: () => {
    const state = get();
    return state.achievements.filter((a) =>
      state.userAchievements.some((ua) => ua.achievement_id === a.achievement_id)
    );
  },
  
  getLearnedConceptsCount: () => {
    return get().learnedConcepts.length;
  },
}));

export default useGameStore;